export default __webpack_public_path__ + "static/media/OpenSans-BoldItalic.9572470e.ttf";